//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'mint-ui';
import { Picker } from 'mint-ui';
import { formatTime, guid, isNullOrEmptyStr } from "@/utils/common"
import { BASIC, FLYBACK_URL } from "@/config/constant"
import promise from '@/axios/promise';
import Message from 'muse-ui-message';
import { debug } from 'util';
export default {
  data() {
    return {
      form: this.$route.query.data,
      flybackList: [],
      // 结算单价类型
      unitPriceTypes: [{ code: 0, name: "现场" }, { code: 1, name: "远程" }],
    }
  },
  methods: {
    // 结算单价类型展示
    unitPriceTypeHandler(unitPriceType) {
      if (unitPriceType != undefined || unitPriceType != null) {
        return this.unitPriceTypes.find(item => item.code === unitPriceType).name;
      }
    },
    //返回
    goBack() {
      this.$router.push({ path: '/app/audit/dayReportAudit' });
    },
    getClass(data) {
      if (data.workTotalSubsidy != data.origTotalSubsidy) {
        return 'colorYellow';
      }
      if (data.workSubsidy != data.origSubsidy) {
        return 'colorYellow';
      }
    },
    getSubsidyClass(data) {
      if (data.workSubsidy > 0) {
        return 'colorRed';
      }
    },
    compareDate(reportTime, createTime) {
      return formatTime(new Date(reportTime), 'yyyy-MM-dd') == formatTime(new Date(createTime), 'yyyy-MM-dd')
    },
    auditPass() {
      this.auditStatus = '已通过';
      this.prompt();
    },
    auditRefuse() {
      this.auditStatus = '被驳回';
      this.prompt();
    },
    prompt() {
      var ids = [];
      ids.push(this.form.id);
      this.$prompt('请输入审核意见', '提示', {
      }).then(({ result, value }) => {
        if (result) {
          this.auditRemark = value;
          this.auditReport(ids);
        } else {
          this.auditRemark = '';
        }
      });
    },
    auditReport(ids) {
      promise({
        url: BASIC + '/dayReport/audit',
        method: 'put',
        params: { status: this.auditStatus, auditRemark: this.auditRemark, idsStr: JSON.stringify(ids) }
      }).then(res => {
        if (res.code == 0) {
          Toast({ message: "操作成功!", duration: 1500, position: 'middle', className: "warning" });
          this.goBack();
        } else {
          Toast({ message: res.msg, duration: 1500, position: 'middle', className: "error" });
        }
      });
    },
  },
  filters: {
    formatDate(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatTime(new Date(date), 'yyyy年MM月dd日')
    },
    formattime(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatTime(new Date(date), 'hh:mm')
    },
    reportTimeFilter(reportTime, createTime) {
      return formatTime(new Date(reportTime), 'yyyy-MM-dd') == formatTime(new Date(createTime), 'yyyy-MM-dd')
    }
  },
  mounted() {
    this.flybackList = this.form.flybackList;
  }
}



// WEBPACK FOOTER //
// ./src/view/sign/dayReportAuditDetail.vue